import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { history } from 'nallian-shared-ui/lib/config/history';
import createRelationService from '../../services/relations/createRelationService';
import RelationForm from './RelationForm';

const EMPTY_RELATION = {};

const NewRelation = ({
  open,
  dispatchCreateRelationPost,
  createRelationFetch,
  communityId,
  rootUrl,
}) => {
  const { t } = useTranslation();

  const handleSubmit = useCallback(
    body => dispatchCreateRelationPost({ ...body, communityId }, () => history.push(rootUrl), t),
    [dispatchCreateRelationPost, communityId, rootUrl, t]
  );

  if (!open) return null;

  return (
    <RelationForm
      header={t('newRelation')}
      onSubmit={handleSubmit}
      submitProcessing={createRelationFetch.pending}
      returnRoute={rootUrl}
      cancelRoute={rootUrl}
      data={EMPTY_RELATION}
      communityId={communityId}
    />
  );
};

NewRelation.propTypes = {
  rootUrl: PropTypes.string.isRequired,
  communityId: PropTypes.string.isRequired,
  dispatchCreateRelationPost: PropTypes.func.isRequired,
  createRelationFetch: PropTypes.object.isRequired,
  open: PropTypes.bool,
};

NewRelation.defaultProps = { open: false };

export default createRelationService(NewRelation);
